import React from "react";
import { ProgressBlock } from "./styled";
import { questionsBlocks } from "../../constants/data";
import okIcon from "./../../resources/images/progressBar/ok_icon.svg";

const ProgressBar = (props) => {
  const { currentBlock, currentQuestion, totalQuestion, specialProgressText } =
    props;

  const questionBlockLinesRender = () => {
    return questionsBlocks.map((block, index) => {
      const isRoundActive =
        currentBlock > index ||
        (currentBlock === index && currentQuestion > totalQuestion);
      return (
        <ProgressBlock.Item key={`progress-${index}`}>
          <ProgressBlock.Line>
            {currentBlock === index && (
              <ProgressBlock.Line.Title>
                <p>
                  {specialProgressText
                    ? specialProgressText
                    : questionsBlocks[index].title}
                </p>
              </ProgressBlock.Line.Title>
            )}
            <ProgressBlock.Line.Load
              active={currentBlock >= index}
              width={
                currentBlock === index
                  ? (currentQuestion / (totalQuestion + 1)) * 100
                  : 100
              }
            />
          </ProgressBlock.Line>
          <ProgressBlock.Round active={isRoundActive}>
            {isRoundActive ? (
              <img src={okIcon} alt="done" />
            ) : (
              <p>{index + 1}</p>
            )}
          </ProgressBlock.Round>
        </ProgressBlock.Item>
      );
    });
  };

  return (
    <ProgressBlock>
      <ProgressBlock.Round active={true} />
      {questionBlockLinesRender()}
    </ProgressBlock>
  );
};

export default ProgressBar;
